import Axios from 'axios';
import { readable, derived } from 'svelte/store';

export const ycTicket = readable({ticket: null, expiration: null}, function start(set) {
  window.setHubValidTicket = function(ticket, validSpan) {
    console.log('Set ticket callback from app');
    set({ticket, validSpan});
  };

  if (/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
    console.log('Set ticket for iOS');
    // iOS will pass the ticket automatically
    // for testing
    //setTimeout(() => window.setHubValidTicket('lBUzg5+WQMiHaezezUtwjQAAAXZJNC+zFSFWFOk4syTD/fnnx9Hi10DDIQ6X+qCHbN6f9femcotrfoHcey/zBxBkgYR6vT9QQfoWdvG832bU6Z6ZkbUb/rUDh71lPuhKtX6/e/+h4AKXlqzxhGjadodZQxEDhdF0', 31536000000), 500);
  } else if (typeof window.YinzNativeApplication != 'undefined') {
    console.log('Set ticket for ANDROID');
    window.YinzNativeApplication.getAppValidTicket();
  } else {
    // for testing
    console.log('Set ticket for WEB (testing)');
    window.setHubValidTicket('lBUzg5+WQMiHaezezUtwjQAAAXZJNC+zFSFWFOk4syTD/fnnx9Hi10DDIQ6X+qCHbN6f9femcotrfoHcey/zBxBkgYR6vT9QQfoWdvG832bU6Z6ZkbUb/rUDh71lPuhKtX6/e/+h4AKXlqzxhGjadodZQxEDhdF0', 31536000000);
  }

  function stopHandler() {
    window.setHubValidTicket = () => {};
  }
  return stopHandler;
});
